exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-cell[data-v-498c59ae] {\n  text-align: center;\n  color: #505050;\n  padding-top: 5vmin;\n  padding-bottom: 5vmin;\n}\n.wrap-text[data-v-498c59ae] {\n  white-space: pre-line;\n  word-break: break-all;\n}\n.vld-overlay[data-v-498c59ae] {\n  position: relative!important;\n}\n.vld-cell[data-v-498c59ae] {\n  display: flex;\n  justify-content: center;\n}\n.vld-loading-icon[data-v-498c59ae] {\n  display:inline-flex;\n}\n.vld-text[data-v-498c59ae] {\n  display:inline-flex;\n  padding-left: 10px;\n}\n.disabled-cell[data-v-498c59ae] {\n  background-color: #F9F6F6;\n}\n\n", ""]);

// exports
